<template>
    <div class="bg-gray-900 p-4">
        <template v-for="lead in leads">
            <app-lead class="" :lead="lead" :key="lead.id"></app-lead>
        </template>
        <template v-for="(team, index) in teams">
            <div class="bg-red-700 m-4 p-1" :key="index"></div>
            <h1 class="text-2xl font-semibold m-4 text-red-700 text-center" :key="index">{{ team.name }}</h1>
            <div class="flex flex-wrap m-4 shadow-xl rounded bg-black p-4" :key="index">
                <template v-for="member in team.members">
                    <app-member class="w-4/12 m-auto mb-4" :member="member" :key="member.id"></app-member>
                </template>
            </div>
        </template>
        
    </div>
</template>

<script>
import Lead from './Lead'
import Member from './Member'
import credits from '../../data/credits'

export default {
    name: 'Timeline',
    data() {
    return credits 
    },
    components: {
        'app-lead': Lead,
        'app-member': Member
    }
}
</script>



// WEBPACK FOOTER //
// src/components/credits/Container.vue